import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Transition } from 'react-transition-group';
import { StyledOverlay, StyledViewportOverlay } from './Overlay.styled';
export var Overlay = /*#__PURE__*/function (_React$Component) {
  function Overlay() {
    var _this;
    _classCallCheck(this, Overlay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Overlay, [].concat(args));
    _defineProperty(_this, "handleOverlayClick", function (ev) {
      var _this$props = _this.props,
        _this$props$closeOnOv = _this$props.closeOnOverlayClick,
        closeOnOverlayClick = _this$props$closeOnOv === void 0 ? true : _this$props$closeOnOv,
        isFullScreen = _this$props.isFullScreen,
        onDismiss = _this$props.onDismiss;
      if (ev.target === ev.currentTarget && !isFullScreen && closeOnOverlayClick && onDismiss) {
        onDismiss();
      }
    });
    return _this;
  }
  _inherits(Overlay, _React$Component);
  return _createClass(Overlay, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        _this$props2$overlayC = _this$props2.overlayClassName,
        overlayClassName = _this$props2$overlayC === void 0 ? '' : _this$props2$overlayC,
        children = _this$props2.children,
        _this$props2$position = _this$props2.position,
        position = _this$props2$position === void 0 ? 'centered' : _this$props2$position;
      return /*#__PURE__*/React.createElement(Transition, {
        appear: true,
        "in": this.props.isOpen,
        timeout: 0
      }, function (animationState) {
        return /*#__PURE__*/React.createElement(StyledViewportOverlay, null, /*#__PURE__*/React.createElement(StyledOverlay, {
          position: position,
          animationState: animationState,
          isFullScreen: _this2.props.isFullScreen,
          className: overlayClassName,
          onMouseDown: _this2.handleOverlayClick
        }, children));
      });
    }
  }]);
}(React.Component);